import React, { useEffect } from 'react'
import { useExitUnsavedFormContext } from '../hooks'
import { useFormikContext } from 'formik'

interface Props<T> {
  onSubmit: (value: T, initialValues?: T) => void
  formKey: string
  children: React.ReactElement
}

/**
 * Forms and their form-changes are registered so that leaving a form with unsaved changes can be reacted on.
 */
export const ExitUnsavedFormHandler = <T,>({ onSubmit, formKey, children }: Props<T>): React.ReactElement => {
  const leaveFormContext = useExitUnsavedFormContext<T>()
  const { values, dirty, isSubmitting, isValid } = useFormikContext<T>()

  useEffect(() => {
    leaveFormContext?.addFormToUnsavedChangedCheck(formKey, dirty && !isSubmitting, isValid, onSubmit, values)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dirty, values, isValid, isSubmitting])

  return <>{children}</>
}
